import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PriceListArea } from '../models/pricelist-area.model';
import { PriceListService } from '../services/pricelist.service';
import { SharedDataStore } from '../store';
import { LoadingService } from '@lx/shared/ui/loading-spinner';
import { map, tap } from 'rxjs';
import { withPriceListResolver } from './price-lists-resolver.mixin';

@Injectable({ providedIn: 'root' })
export class PriceListsDefaultYearResolverService {
  private readonly priceListService = inject(PriceListService);
  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  private readonly mixin = withPriceListResolver({
    priceListService: this.priceListService,
    sharedDataStore: this.sharedDataStore,
    loadingService: this.loadingService,
    router: this.router,
  });

  resolve(priceListArea: PriceListArea, route: ActivatedRouteSnapshot) {
    if (route.children?.length > 0) {
      return null;
    }

    const yearAndAccess$ = this.sharedDataStore.privateAccessAndCurrentPriceListYear$.pipe(
      tap(({ currentPriceListYear }) => {
        this.sharedDataStore.updateState({ currentPriceListYear });
      }),
      map(({ currentPriceListYear, privateAccess }) => ({ year: currentPriceListYear, privateAccess })),
    );

    return this.mixin.resolvePriceLists$(priceListArea, yearAndAccess$);
  }
}
